import { __extends } from "tslib";
import { deserializeAws_restXmlRestoreObjectCommand, serializeAws_restXmlRestoreObjectCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var RestoreObjectCommand = /** @class */ (function (_super) {
    __extends(RestoreObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function RestoreObjectCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    RestoreObjectCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    RestoreObjectCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlRestoreObjectCommand(input, context);
    };
    RestoreObjectCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlRestoreObjectCommand(output, context);
    };
    return RestoreObjectCommand;
}($Command));
export { RestoreObjectCommand };
//# sourceMappingURL=RestoreObjectCommand.js.map